import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const SessionContext = createContext(null);
export const useSession = () => useContext(SessionContext);

export const SessionProvider = ({ children }) => {
  const [session, setSession] = useState(null);
  const [config, setConfig] = useState({ demo_mode: true });
  const [ready, setReady] = useState(false);
  const [asOf, setAsOf] = useState("latest");

  const applyToken = (data) => {
    if (data.token) localStorage.setItem("pmo_token", data.token);
    setSession({ persona: data.persona, label: data.label, role: data.role, platform: data.platform });
  };

  useEffect(() => {
    (async () => {
      try {
        const cfg = await api.get("/config");
        setConfig(cfg.data);
        // Preserve a valid existing session; otherwise (demo) mint default Admin.
        const res = await api.post("/session/bootstrap");
        applyToken(res.data);
      } catch (e) {
        localStorage.removeItem("pmo_token");
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const selectPersona = useCallback(async (persona_id) => {
    const res = await api.post("/session", { persona_id });
    applyToken(res.data);
    setAsOf("latest");
    return res.data;
  }, []);

  const resetDemoSession = useCallback(async () => {
    localStorage.removeItem("pmo_token");
    const res = await api.post("/session", { persona_id: config.default_demo_persona || "pmo" });
    applyToken(res.data);
    setAsOf("latest");
  }, [config]);

  return (
    <SessionContext.Provider value={{ session, config, ready, selectPersona, resetDemoSession, asOf, setAsOf }}>
      {children}
    </SessionContext.Provider>
  );
};
